import { render, staticRenderFns } from "./parentProfile.vue?vue&type=template&id=aaae9f5c&scoped=true&"
import script from "./parentProfile.vue?vue&type=script&lang=js&"
export * from "./parentProfile.vue?vue&type=script&lang=js&"
import style0 from "./parentProfile.vue?vue&type=style&index=0&id=aaae9f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaae9f5c",
  null
  
)

export default component.exports